import React from "react";

import LeftMenu from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/LeftMenu";
import MeetingType from "./MeetingType/MeetingType";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const ManageIncidents = () => {
  return (
    <div className="healthSafetyEnvironmentWrapper">
      <LeftMenu active={4} />

      <div className="tst-class mt-4">
        <MeetingType />
        <div className="training-seperator"></div>

        {/* <OneColumnTable title="Categories" name="Category" type="Category" /> */}
        <div className="training-seperator"></div>

        {/* <AreaOfOperation
          title="Area Of Operation"
          name="Area Of Operation"
          type="Work Area"
        /> */}
        <div className="training-seperator"></div>

        {/* <Activity title="Activity" name="Activity" /> */}

        <div className="training-seperator"></div>
      </div>
    </div>
  );
};

export default ManageIncidents;
